export default __webpack_public_path__ + "static/media/video.0325cfcb.m4v";